import { IAction } from '~/src/store';
import { INewMenuItems } from '~/src/store/reducers/menu';

import { SET_MENU_DATA } from '../actionTypes/menu';

export const setMenuData = (newMenuItems: INewMenuItems): IAction<typeof SET_MENU_DATA, INewMenuItems> => ({
    type: SET_MENU_DATA,
    payload: newMenuItems,
});
